import { deleteScheduleByExternalId } from '@dispatch/shared/services';
import { useMutate } from '../api/useMutate';

export const useDeleteScheduleByExternalId = (
  responseFn: (data: { success: boolean }) => void | Promise<unknown>
) => {
  const { mutate, error, status } = useMutate(
    'delete-schedule-by-externalid',
    (externalId: string) => deleteScheduleByExternalId(externalId),
    responseFn as (data: unknown) => void | Promise<unknown>
  );

  return {
    deleteSchedule: mutate,
    error,
    status,
  };
};
